import { Stack, Typography } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

import IdeaCardContent from './IdeaCardContent';
import type { Idea } from '../../interfaces/Idea';

export interface PdfIdeaCardProps {
  showBackground: boolean;
  idea: Idea;
}

const PdfIdeaCard = ({ showBackground, idea }: PdfIdeaCardProps) => {
  const filename = (idea.title?.trim() || idea.content?.trim() || 'PDF document').trim();

  return (
    <IdeaCardContent showBackground={showBackground} showPadding={true}>
      <Stack direction="row" spacing={1.25} alignItems="flex-start">
        <PictureAsPdfOutlinedIcon sx={{ color: '#e1386a', fontSize: 32, flexShrink: 0 }} />
        <Typography
          variant="body2"
          sx={{
            pt: 0.75,
            lineHeight: 1.35,
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
          }}
          dangerouslySetInnerHTML={{ __html: filename }}
        />
      </Stack>
    </IdeaCardContent>
  );
};

export default PdfIdeaCard;
